module.exports = __webpack_public_path__ + "img/avatar-2.b2751c79.jpg";